import React, { useEffect } from 'react'
import { Avatar, Button, } from "@mui/material";
import profile from '../../assets/image/Player.jpg'
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch } from '../../useStore';
import axios from 'axios';
import { logout, reset } from '../../features/Auth/authSlice';
import { useNavigate } from 'react-router-dom';
import DataService from '../../features/Auth/dataService';
import AccountCircle from '@mui/icons-material/AccountCircle';

const DropdownMenu = ({ setDropDown }: any) => {
	// @ts-ignore
	const userInfo = JSON.parse(localStorage.getItem("user_ats"));
	const dispatch = useAppDispatch()
	const dataService = DataService();
	const navigate = useNavigate();



	const handelLogout = () => {
		dispatch(logout());
		navigate("/");
		dataService.clearData()
		delete axios.defaults.headers.common['Authorization'];
		dispatch(reset());
	};

	useEffect(() => {
		if (!userInfo || userInfo == null) {
			navigate("/");
			dispatch(reset());
		}
	}, [dataService, dispatch, navigate, userInfo]);

	useEffect(() => {
		if (!userInfo) {
			delete axios.defaults.headers.common['Authorization'];
			dataService.clearData()
			navigate("/");
			dispatch(reset());
			dataService.clearData()
		}

	}, [dataService, dispatch, navigate, userInfo])




	return (
		<div className="dropdown_menu"  >
			<div className="dropdown_menu_update">
				<div>UPDATE  PROFILE</div>
				<div>
					<CloseIcon onClick={() => setDropDown(false)} />
				</div>
			</div>
			<div className="dropdown_menu_update_dropdown">
				<div>
					{/* <Avatar className="headerOption_icon_update"
						src={profile} >
					</Avatar> */}
					<AccountCircle fontSize="medium" className="headerOption_icon_update" />
				</div>
				<div className="headerOption_icon_update_text">
					<p id="headerOption_icon_update_one">{userInfo?.user?.firstName} {userInfo?.user?.LastName} </p>
					<p className="headerOption_icon_update_two">{userInfo?.user?.email} </p>
				</div>
			</div>
			<div className="dropdown_menu_options-container_two">
				<h5 className="dropdown_menu_options-container_two_h5">Edit</h5>
				<div className="dropdown_container_two_menu">
					<div>
						<p id="headerOption_icon_update_one">User Information</p>
						<p className="headerOption_icon_update_two">Godwin Chinedu</p>
					</div>
				</div>
				<div className="dropdown_container_two_menu">
					<div>
						<p id="headerOption_icon_update_one">Change Password</p>
						<p className="headerOption_icon_update_two">XXXXXX</p>
					</div>
				</div>
				<div className="dropdown_container_two_menu">
					<div id="headerOption_icon_update_one">
						<p>About</p>
						<p className="headerOption_icon_update_two">Get your job in front of quality candidates</p>
					</div>
				</div>
				{/* <div className="dropdown_container_two_menu_four">
					<div>
						<div>
							<p id="headerOption_icon_update_one">Upload Image</p>
							<p className="headerOption_icon_update_two">select an image</p>
						</div>
					</div>
					<div className="dropdown_two_menu_camera_icon"><BsCamera /></div>
				</div> */}
				{/* <div id="update_profile_name">UPDATE PROFILE</div> */}
			</div>
			<Button className="dropdown_two_menu_logout" onClick={handelLogout}>
				Logout
			</Button>
		</div>
	)
}

export default DropdownMenu


